import {getReportParams, report} from '../../../../middleware/report';
import {
  OwnershipTransferActionType,
  EquipmentPaymentObligation,
  OwnershipTransferActionTypeDescription,
  RequestStatusDescription,
} from '../Constant/Constant';

export const DWHStatus = {
  Ongoing: 'Ongoing',
  Completed: 'Completed',
  Error: 'Error',
}

export const DwhActionType = {
  StatusTable: 'Status table',
  SuccessScreen: 'Success Screen',
  ErrorScreen: 'Error Screen',
  OwnershipTypePage: 'Ownership Type page',
  LineSearchPage: 'Line Search page',
  EquipmentChargesPage: 'Equipment Charges page',
  LineOwnerDetailPage: 'Line Owner Detail page',
  CustomerDetailPage: 'Customer Detail page',
}
export const DWHMessageText = {
  StatusTablePageDisplayed: 'Status table page Displayed',
  StatusTableNewTransferButtonClicked: 'Status table New Transfer Button Clicked',
  StatusTableStatusCheckButtonClicked: 'Status table Status check Button Clicked',
  CancelTransferButtonClicked: 'Cancel Transfer Button Clicked',
  CancelTransferEnsurePopupDisplayed: 'Cancel Transfer Ensure Popup Displayed',
  CancelTransferEnsurePopupButtonClicked: 'Cancel Transfer Ensure Popup Button Clicked',
  CancelTransferSuccessScreen: 'Cancel Transfer Success Screen',
  ResendingButtonClicked: 'Resending Button Clicked',
  ResendingSuccessScreen: 'Resending Success Screen',
  OwnershipTypePageDisplayed: 'Ownership Type page Displayed',
  OwnershipTypePageButtonClicked: 'Ownership Type page Button Clicked',
  LineSearchPageDisplayed: 'Line Search page Displayed',
  LineSearchPageSearchButtonClicked: 'Line Search page Search Button Clicked',
  LineSearchPageButtonClicked: 'Line Search page Button Clicked',
  ErrorAlreadyExistsTransferRequest: 'Error Already Exists Transfer Request',
  ErrorNotInOrganizationAnotherOrganization: 'Error Not in organization - another organization',
  ErrorNotInOrganization: 'Error Not in organization',
  ErrorLineOwnerPostponed: 'Error Line Owner postponed',
  ErrorLineOwnerBNIYOD: 'Error Line Owner BNIYOD',
  ErrorLineOwnerIsAbroad: 'Error Line Owner is abroad',
  PopupDataLineDisplayed: 'Popup Data Line Displayed',
  EquipmentChargesPageDisplayed: 'Equipment Charges page Displayed',
  EquipmentChargesPageYESButtonClicked: 'Equipment Charges page YES Button Clicked',
  EquipmentChargesPageNOButtonClicked: 'Equipment Charges page NO Button Clicked',
  LineOwnerDetailPageDisplayed: 'Line Owner Detail page Displayed',
  LineOwnerDetailPageButtonClicked: 'Line Owner Detail page Button Clicked',
  CustomerDetailPageDisplayed: 'Customer Detail page Displayed',
  CustomerDetailPageButtonClicked: 'Customer Detail page Button Clicked',
  SuccessScreen: 'Success Screen',
  GeneralError: 'General Error ',
}

function getEquipmentTitle(data) {
  if (data.selectedPhoneNumber) {
    if (data.currentEquipmentObligations.length == 0) {
      return 'לא קיים ';
    } else {
      if (data.responsibleForNextPayments === EquipmentPaymentObligation.Customer) {
        return 'מועבר למנוי';
      } else {
        return 'נשאר בחברה';
      }
    }
  } else {
    return '';
  }
}
function getRowEquipmentTitle(row) {
  if (row.equipmentObligations == EquipmentPaymentObligation.None) {
    return 'לא קיים ';
  }

  if (row.actionType == OwnershipTransferActionType.BusinessToPrivate) {
    if (row.equipmentObligations == EquipmentPaymentObligation.Customer) {
      return 'מועבר למנוי';
    } else {
      return 'נשאר בחברה';
    }
  }
}

export function dwhGeneralReport({data, actionType, messageText, status}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'OwnershipTransfer - Customer';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = actionType;
  reportParams.status = status;
  reportParams.messageText = messageText;
  reportParams.param1 = data.portalsBlock?.selectedHetPay;
  reportParams.param2 = data.selectedPhoneNumber ?? '';
  reportParams.param3 =
    data.contactPersonSendFormType.type == 'email' ? data.contactPersonSendFormType.email : data.contactPersonSendFormType.sms;
  reportParams.param4 = data.subscriberSendFormType.type == 'email' ? data.subscriberSendFormType.email : data.subscriberSendFormType.sms;
  reportParams.param5 = data.subscriberPersonalData.firstName + ' ' + data.subscriberPersonalData.lastName;
  reportParams.param6 = data.subscriberPersonalData.idNumber;
  reportParams.param7 = getEquipmentTitle(data);
  reportParams.param8 = data.portalsBlock?.selectedOrgName;
  reportParams.param9 = OwnershipTransferActionTypeDescription[data.selectedActionType];
  reportParams.param10 = data.jetConnection ? 'אחראית שירות' : 'איש קשר';
  reportParams.idNumber = data.userDetails?.IDNumber;
  reportParams.customerName = `${data.userDetails?.firstName} ${data.userDetails?.lastName}`;
  reportParams.subscriber = data.userDetails?.contactNumber;
  report(reportParams);
}

export function dwhDashboardReport({data, actionType, messageText, status}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'OwnershipTransfer - Customer table';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = actionType;
  reportParams.status = status;
  reportParams.messageText = messageText;
  reportParams.param1 = data.portalsBlock?.selectedHetPay;
  reportParams.param2 = data.row ? data.row.subscriberPhoneNumber : '';
  reportParams.param3 = data.row ? data.row.contactPersonFormMethodValue : '';
  reportParams.param4 = data.row ? data.row.subscriberFormMethodValue : '';
  reportParams.param5 = data.row ? data.row.subscriberFirstName + ' ' + data.row.subscriberLastName : '';
  reportParams.param6 = data.row ? data.row.subscriberIdNumber : '';
  reportParams.param7 = data.row ? getRowEquipmentTitle(data.row) : '';
  reportParams.param8 = data.portalsBlock?.selectedOrgName;
  reportParams.param9 = data.row ? OwnershipTransferActionTypeDescription[data.row.actionType] : '';
  reportParams.param10 = data.row ? RequestStatusDescription[data.row.statusCodeDescription] : '';
  reportParams.idNumber = data.userDetails?.IDNumber;
  reportParams.customerName = `${data.userDetails?.firstName} ${data.userDetails?.lastName}`;
  reportParams.subscriber = data.userDetails?.contactNumber;
  report(reportParams);
}
